export const API_EXTERNAL_ENDPOINT = 'cottages/detail/:province/:slug'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/detail'
